import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import classNames from 'classnames';
import style from './PricesList.module.scss';

interface IPricesListRestaurant {
	id: string;
	restaurantName: Nullable<string>;
	price: Nullable<number>;
	currencySymbol?: Nullable<string>;
}

interface IPricesList {
	restaurants: IPricesListRestaurant[];
	selectedRestaurant?: {
		currencySymbol: Nullable<string>;
		price: Nullable<number>;
	};
}

const PricesList: React.FC<IPricesList> = ({ restaurants, selectedRestaurant }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);
	const showListBtnClasses = classNames(style.showListBtn, {
		[style.marginLeft]: selectedRestaurant?.currencySymbol,
	});

	const RestaurantsContent = () => {
		return (
			<div className={style.container} data-test="RestaurantsContent">
				{accessibleRestaurants.map((el) => (
					<div className={style.item} key={el.id}>
						<Text translationKey={`${el.restaurantName} / ${el.price}`} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<div data-test="PricesList">
			{accessibleRestaurants.length > 1 && (
				<Pop placement="bottomLeft" content={<RestaurantsContent />} trigger="click">
					<div className={style.wrapper}>
						<Text
							translationKey={
								selectedRestaurant
									? `${selectedRestaurant.currencySymbol ? selectedRestaurant.currencySymbol : ''}${
											selectedRestaurant.price
									  }`
									: ' '
							}
							withTooltip={true}
						/>
						<span className={showListBtnClasses}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			)}
			{accessibleRestaurants.length === 1 && selectedRestaurant && (
				<Text
					translationKey={
						selectedRestaurant
							? `${selectedRestaurant.currencySymbol ? selectedRestaurant.currencySymbol : ''}${
									selectedRestaurant.price
							  }`
							: '-'
					}
					withTooltip={true}
				/>
			)}
			{accessibleRestaurants.length === 1 && !selectedRestaurant && (
				<Text
					translationKey={
						accessibleRestaurants
							? `${
									accessibleRestaurants[0].currencySymbol
										? accessibleRestaurants[0].currencySymbol
										: ''
							  }${accessibleRestaurants[0].price}`
							: '-'
					}
					withTooltip={true}
				/>
			)}
			{accessibleRestaurants.length === 0 && !selectedRestaurant && (
				<Text translationKey="-" withTooltip={true} />
			)}
		</div>
	);
};

export default React.memo(PricesList);
